document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('.p-job-tabs__tab');
    const contents = document.querySelectorAll('.p-job-tabs__content');

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const tabIndex = tab.dataset.tabIndex;

            // タブのアクティブ状態を更新
            tabs.forEach(t => t.classList.remove('is-active'));
            tab.classList.add('is-active');

            // コンテンツの表示を切り替え
            contents.forEach(content => {
                if (content.dataset.contentIndex === tabIndex) {
                    content.classList.add('is-active');
                } else {
                    content.classList.remove('is-active');
                }
            });
        });
    });
}); 